import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import { useSelector } from "react-redux";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { LICENSE_API_02 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useTheme } from "@mui/material/styles";
import { paymenthistorydata } from "../../assets/Griddata";
import currencyFormat, { formatDate } from "../../utils/common/CurrencyFormat";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
function PaymentHistory() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE } = SYS_USER.USER_PARAM || {};
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const result = await externalgetApi(LICENSE_API_02, "get", {
          COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [COMPCODE]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        PAYMENTID: item.PAYMENTID,
        INVOICENO: item.INVOICENO,
        DUETODATE: formatDate(item.DUETODATE),
        NEXTDUEDATE: formatDate(item.NEXTDUEDATE),
        LICENSEVALUE: currencyFormat(item.LICENSEVALUE),
        NETTVALUE: currencyFormat(item.NETTVALUE),
        DISCOUNT: item.DISCOUNT,
      }))
    : [];

  const handleItemClick = (id, actionText) => {
    if (actionText === "View") {
      const selectedItem = data.find((item) => item.PAYMENTID === id);
      if (selectedItem) {
        // Open a new tab and pass the PAYMENTID in the query parameter
        const newTabUrl = `/Paymentdetails?paymentId=${id}&actionText=${actionText}`;
        window.open(newTabUrl, "_blank");
      }
    } else {
      const newTabUrl = `/Paymentdetails?actionText=${actionText}`;
      window.open(newTabUrl, "_blank");
    }
  };

  const menuItems = [
    {
      text: "Invoice Details",
      icon: <InsertDriveFileIcon />,
      onClick: (PAYMENTID) => handleItemClick(PAYMENTID, "View"),
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none"> Account</Link>
                <Link underline="none">Payment History</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                  id="search"
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : error ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <p>{error}</p>
        </Box>
      ) : (
        <ViewData
          columns={paymenthistorydata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={paymenthistorydata.name}
          gridid="PAYMENTID"
        />
      )}
    </div>
  );
}

export default PaymentHistory;
